import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  CircularProgress
} from "@material-ui/core";
import { ShowChart } from "@material-ui/icons";
import useStyles from "./styles";
import useModuleStyles from "../../styles";
import { Line } from "react-chartjs-2";
import React from "react";
import { DashBoardLineChartProps } from "./types";

const DashBoardLineChart = ({
  title,
  chartData,
  isLoading,
  options
}: DashBoardLineChartProps) => {
  const classes = useStyles();
  const moduleClasses = useModuleStyles();

  return (
    <Card elevation={0}>
      <CardHeader
        title={title}
        className={classes.header}
        avatar={
          <Avatar aria-label={title} className={classes.avatar}>
            <ShowChart />
          </Avatar>
        }
      />
      <CardContent className={classes.container}>
        <Line
          options={
            options
              ? options
              : {
                  scales: {
                    x: {
                      ticks: {
                        autoSkip: true,
                        maxTicksLimit: 20
                      }
                    }
                  }
                }
          }
          data={{
            labels: chartData.labels,
            datasets: chartData.datasets
          }}
        />
        {!isLoading ? (
          <></>
        ) : (
          <div className={moduleClasses.spinnerContainer}>
            <CircularProgress />
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default DashBoardLineChart;
